<template>
  <Transition name="slide-fade">
    <slot />
  </Transition>
</template>

<style lang="scss">
.slide-fade-enter-active {
  transition: all 0s;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
}
</style>
